<div class="content-placeholder">  
  <div class="header-container">
    <div>
      <span class="title"></span>
    </div>
    <p class="description"></p>
  </div>
  <div class="form-cont-parent">
    <div class="upsell-table">
      <div class="upsell-table-container">
        <div class="upsell-column title">
          <div class="upsell-column-item title"></div>
          <div class="upsell-column-item" *ngFor="let i of [].constructor(7)">
            <strong></strong>
          </div>
          <div class="upsell-column-item footer"></div>
        </div>
        <div class="upsell-column" *ngFor="let i of [].constructor(3)">
          <div class="upsell-column-item title"></div>
          <div class="upsell-column-item" *ngFor="let i of [].constructor(7)">
            <span class="icon"><i></i></span>
          </div>
          <div class="upsell-column-item footer">
            <div class="radio">
              <label></label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-container">
    <span class="button"></span>
  </div>
</div>